export default __webpack_public_path__ + "static/media/functionalities.1f9afa16.png";